module.exports = __webpack_public_path__ + "static/media/right-arrow.ef9bb44e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/right-arrow.svg
// module id = 43
// module chunks = 0